
import { ServiceData, Testimonial, GalleryImage, FAQ } from './types';

export const COMPANY_NAME = "Palmal Decorators";
export const PHONE_NUMBER = "+91 94343 85520";
export const WHATSAPP_NUMBER = "919434385520"; // Format for link
export const ADDRESS = "Judges Court Rd, near TV tower Ground, Midnapore, West Bengal 721101";
export const GOOGLE_MAPS_LINK = "https://maps.app.goo.gl/WFURGy2EvWyuqWZE8";
export const GOOGLE_REVIEWS_LINK = "https://maps.app.goo.gl/hyqAsX9Ubo8bSoN99";
export const EMAIL = "palmaldecorators02@gmail.com";
export const YOUTUBE_LINK = "https://www.youtube.com/@PalmalDecorators";
export const INSTAGRAM_LINK = "https://www.instagram.com/palmaldecorators?igsh=MWxyYWk0NHZmbGdwZg==";
export const FACEBOOK_LINK = "https://www.facebook.com/share/14UjzZGdaQ3/";

export const SERVICE_AREAS = [
  "Midnapore Town",
  "Kharagpur",
  "Ghatal",
  "Jhargram",
  "Salboni",
  "Garhbeta",
  "Debra",
  "Keshpur",
  "Paschim Medinipur"
];

export const SERVICES: ServiceData[] = [
  {
    id: "wedding-planning",
    title: "Wedding & Bridal",
    shortDescription: "Complete marriage planning, bridal shows, and theme weddings.",
    fullDescription: "We offer end-to-end wedding management services. From bridal show management to the actual marriage ceremony, our team ensures every ritual and reception is flawless. We specialize in destination weddings, theme-based setups, and coordinating all aspects of your big day.",
    features: ["Bridal Show Mgmt", "Theme Weddings", "Sangeet & Mehendi", "Reception Planning"],
    imageUrl: "https://images.unsplash.com/photo-1519741497674-611481863552?auto=format&fit=crop&q=80&w=800",
    iconName: "Heart"
  },
  {
    id: "corporate-conference",
    title: "Corporate & Conference",
    shortDescription: "Professional management for conferences, seminars, and corporate events.",
    fullDescription: "Elevate your business profile with our expert corporate event management. We handle conferences, seminars, product launches, and annual general meetings. Our services include audio-visual setup, stage branding, and seamless coordination for professional gatherings.",
    features: ["Conference Setup", "Product Launches", "Seminars", "Exhibition Stalls"],
    imageUrl: "https://images.unsplash.com/photo-1511578314322-379afb476865?auto=format&fit=crop&q=80&w=800",
    iconName: "Briefcase"
  },
  {
    id: "social-events",
    title: "Social Celebrations",
    shortDescription: "Birthdays, anniversaries, baby showers, and private parties.",
    fullDescription: "Make every milestone memorable. We plan and execute birthday parties, anniversary celebrations, baby showers, and rice ceremonies. Whether it's a Bar/Bat Mitzvah or a golden jubilee, we provide themed decor and entertainment to keep your guests delighted.",
    features: ["Baby Shower", "Anniversaries", "Birthday Parties", "Bar & Bat Mitzvah"],
    imageUrl: "https://lh3.googleusercontent.com/d/1L64aDaJ-V4WuZXdH67ejOWv595r00A2q",
    iconName: "PartyPopper"
  },
  {
    id: "catering-services",
    title: "Catering Services",
    shortDescription: "Exquisite culinary experiences for weddings and events.",
    fullDescription: "Delight your guests with our premium catering services. We offer customized menus featuring authentic Bengali cuisine, North Indian delicacies, and Continental favorites. Our hygiene-focused approach ensures fresh, delicious food served with style.",
    features: ["Buffet Service", "Live Food Counters", "Corporate Lunch", "Wedding Feast"],
    imageUrl: "https://images.unsplash.com/photo-1555244162-803834f70033?auto=format&fit=crop&q=80&w=800",
    iconName: "Utensils"
  },
  {
    id: "religious-festivals",
    title: "Durga Puja & Pandal",
    shortDescription: "Grand pandal construction and decoration for religious festivals.",
    fullDescription: "We specialize in designing and constructing magnificent pandals for Durga Puja, Kali Puja, and other religious festivals. Our team combines artistic creativity with structural safety to build awe-inspiring temporary structures and idol decorations.",
    features: ["Pandal Design", "Idol Decoration", "Lighting Effects", "Crowd Management"],
    imageUrl: "https://lh3.googleusercontent.com/d/1zoGlvmNscdFEuTUakWXOGxg0Mie4Ok2C",
    iconName: "Tent"
  },
  {
    id: "stage-decor",
    title: "Stage & Floral Decor",
    shortDescription: "Stunning stage designs and floral arrangements for all occasions.",
    fullDescription: "The stage is the center of attention. We create breathtaking stage backdrops and floral mandaps using fresh and artificial flowers. Our lighting and prop designs ensure your venue looks magical in photos and reality.",
    features: ["Floral Mandaps", "Stage Backdrops", "Venue Styling", "Entrance Decor"],
    imageUrl: "https://images.unsplash.com/photo-1478146059778-26028b07395a?auto=format&fit=crop&q=80&w=800",
    iconName: "Gem"
  }
];

export const TESTIMONIALS: Testimonial[] = [
  {
    id: 1,
    name: "Amit Maiti",
    location: "Midnapore",
    text: "Palmal Decorators did an amazing job for my sister's wedding. The floral mandap and catering were breathtaking. Highly recommended!",
    rating: 5
  },
  {
    id: 2,
    name: "Priya Das",
    location: "Kharagpur",
    text: "Best event management company in the district. They managed our corporate conference professionally.",
    rating: 5
  },
  {
    id: 3,
    name: "Rahul Ghosh",
    location: "Ghatal",
    text: "Very reasonable prices for such high-quality work. The balloon decoration for my son's birthday was superb.",
    rating: 4
  }
];

export const GALLERY_IMAGES: GalleryImage[] = [
  {
    id: "client-wedding-new-30",
    url: "https://lh3.googleusercontent.com/d/1MdZnfWXuzNCOU_9yReeP7bhEx7fpTt1z",
    category: "Wedding",
    alt: "Luxury Floral Wedding Stage Design"
  },
  {
    id: "client-wedding-new-29",
    url: "https://lh3.googleusercontent.com/d/161tdJfB5PMXJuMu3F2dw47FMYkKF8dlY",
    category: "Wedding",
    alt: "Elegant Wedding Reception Decor"
  },
  {
    id: "client-wedding-new-28",
    url: "https://lh3.googleusercontent.com/d/1SY4MdIsIP_nYa1BdL_1DpImbkK-tNlGn",
    category: "Wedding",
    alt: "Grand Indian Wedding Mandap"
  },
  {
    id: "client-wedding-new-27",
    url: "https://lh3.googleusercontent.com/d/1twC9QUxZON23_yo2-t3TIXva6SqvvCTn",
    category: "Wedding",
    alt: "Traditional Floral Stage Setup"
  },
  {
    id: "client-wedding-new-26",
    url: "https://lh3.googleusercontent.com/d/1WCbDWpQFIwo5PJnHqcyhAX21T1ewKeDI",
    category: "Wedding",
    alt: "Beautiful Wedding Entrance Arch"
  },
  {
    id: "client-wedding-new-25",
    url: "https://lh3.googleusercontent.com/d/1gqZHH4xQDrSbT4z9LIh-dg1fZ04W4YA_",
    category: "Wedding",
    alt: "Modern Wedding Stage Decoration"
  },
  {
    id: "client-wedding-new-24",
    url: "https://lh3.googleusercontent.com/d/1IbyuqwAhMyOip0IrFEbzcSC1euwgnz8F",
    category: "Wedding",
    alt: "Premium Floral Wedding Decor"
  },
  {
    id: "client-wedding-new-23",
    url: "https://lh3.googleusercontent.com/d/1BsInNoVhouTy5rQfLNitax_J4Cx_abvL",
    category: "Wedding",
    alt: "Royal Reception Stage Setup"
  },
  {
    id: "client-wedding-new-22",
    url: "https://lh3.googleusercontent.com/d/1VbUD2oBTCvBWp0nhguZFP-M9ykKOoOTQ",
    category: "Wedding",
    alt: "Grand Wedding Venue Decoration"
  },
  {
    id: "client-wedding-new-21",
    url: "https://lh3.googleusercontent.com/d/1sKEDXFcEKlyM4K4m5mcSTdvOFXoTo3Wi",
    category: "Wedding",
    alt: "Luxurious Wedding Stage & Floral Arrangement"
  },
  {
    id: "client-wedding-new-20",
    url: "https://lh3.googleusercontent.com/d/1yobINEOvdyRPqx1V_zCPrtreWrmaOjSu",
    category: "Wedding",
    alt: "Traditional Bengali Wedding Setup"
  },
  {
    id: "client-wedding-new-19",
    url: "https://lh3.googleusercontent.com/d/1ItZwXKSgxEuS4ofhoV9Ap9IHq5og8uet",
    category: "Wedding",
    alt: "Elegant Floral Wedding Entrance"
  },
  {
    id: "client-wedding-new-18",
    url: "https://lh3.googleusercontent.com/d/13xz9KU3r0KDJ09M65wF02gVORgT_mqw2",
    category: "Wedding",
    alt: "Grand Reception Stage Decor"
  },
  {
    id: "client-wedding-new-17",
    url: "https://lh3.googleusercontent.com/d/1x-eEIQGzvffz0boh9AH5ztfMzJCjBJ4o",
    category: "Wedding",
    alt: "Premium Wedding Mandap Decoration"
  },
  {
    id: "client-wedding-new-16",
    url: "https://lh3.googleusercontent.com/d/1BK-7U4a6Krt85mlmx08K6GZ8JAxC6AWN",
    category: "Wedding",
    alt: "Royal Wedding Venue Lighting & Decor"
  },
  {
    id: "client-wedding-new-15",
    url: "https://lh3.googleusercontent.com/d/1uzXqEgEIrJpCR-DntlZkqdJUDrEhCkMZ",
    category: "Wedding",
    alt: "Royal Wedding Stage Decoration"
  },
  {
    id: "client-wedding-new-14",
    url: "https://lh3.googleusercontent.com/d/1RJFOF6C1sP1PG02CbUrf5vj7H5rBH-h4",
    category: "Wedding",
    alt: "Grand Wedding Mandap & Stage Decor"
  },
  {
    id: "client-wedding-new-13",
    url: "https://lh3.googleusercontent.com/d/12sQinFuwKBgENvuHmYb8quGI28xAFgEb",
    category: "Wedding",
    alt: "Grand Wedding Stage & Floral Setup"
  },
  {
    id: "client-wedding-new-12",
    url: "https://lh3.googleusercontent.com/d/1IwelqClGGDMCeFU0jhKtWGYNEdwfDDzM",
    category: "Wedding",
    alt: "Elegant Wedding Stage Decoration"
  },
  {
    id: "client-wedding-new-11",
    url: "https://lh3.googleusercontent.com/d/1rMqubRMIGkbS8T5-eUmU_MY9ekJoTSam",
    category: "Wedding",
    alt: "Royal Wedding Stage & Floral Decor"
  },
  {
    id: "client-wedding-new-10",
    url: "https://lh3.googleusercontent.com/d/1zaHl_3MvP2FUaZTyPNP-YnKHVQBoKJ3i",
    category: "Wedding",
    alt: "Grand Wedding Reception Decoration"
  },
  {
    id: "client-wedding-new-9",
    url: "https://lh3.googleusercontent.com/d/18TAUsA4HWA-od6MUcGCebcJo_J6HLUt2",
    category: "Wedding",
    alt: "Luxury Wedding Entrance Walkway"
  },
  {
    id: "client-wedding-new-8",
    url: "https://lh3.googleusercontent.com/d/1M53PHA49r6pEVEt7Fb2pUUG5nFUYUmAT",
    category: "Wedding",
    alt: "Grand Wedding Entrance Decoration"
  },
  {
    id: "client-wedding-new-7",
    url: "https://lh3.googleusercontent.com/d/1oaevkiYYBI3P-BGxPMIbxtAHkP2-gZpq",
    category: "Wedding",
    alt: "Grand Wedding Stage Decoration"
  },
  {
    id: "client-wedding-new-6",
    url: "https://lh3.googleusercontent.com/d/1yUhqkeQyHQ5drk69IdEThfIBSs55QLa9",
    category: "Wedding",
    alt: "Luxurious Wedding Mandap Setup"
  },
  {
    id: "client-wedding-new-5",
    url: "https://lh3.googleusercontent.com/d/14NWDzIciCSG2bKds2igYyTT7ruo7_8dv",
    category: "Wedding",
    alt: "Exquisite Wedding Stage Design"
  },
  {
    id: "client-wedding-new-4",
    url: "https://lh3.googleusercontent.com/d/1J1bAHurglEwo-mYh_VqkGyrtVm4Pl0sX",
    category: "Wedding",
    alt: "Royal Wedding Entrance & Walkway"
  },
  {
    id: "client-wedding-new-3",
    url: "https://lh3.googleusercontent.com/d/19YeBLkaBeg2rPGGf0pzkgiHW_0Uz6fMy",
    category: "Wedding",
    alt: "Beautiful Wedding Venue Decoration"
  },
  {
    id: "client-wedding-new-2",
    url: "https://lh3.googleusercontent.com/d/1Msvueh-E1VPKJD4VW9mQEoHjKBu_p5bT",
    category: "Wedding",
    alt: "Grand Entrance Walkway Decoration"
  },
  {
    id: "client-wedding-new-1",
    url: "https://lh3.googleusercontent.com/d/1nXu5U9pa8dvqifEA_2hs-Ix8Eip58E6-",
    category: "Wedding",
    alt: "Elegant Wedding Aisle & Stage Decor"
  },
  {
    id: "client-wedding-1",
    url: "https://lh3.googleusercontent.com/d/11O3bVng4N817HAsKoaIRbrcGxw1D1_Vm",
    category: "Wedding",
    alt: "Luxury Wedding Decoration by Palmal Decorators"
  },
  {
    id: "stage-1",
    url: "https://images.unsplash.com/photo-1478146059778-26028b07395a?auto=format&fit=crop&q=80&w=1200",
    category: "Stage",
    alt: "Floral Stage Decoration"
  },
  {
    id: "catering-1",
    url: "https://images.unsplash.com/photo-1555244162-803834f70033?auto=format&fit=crop&q=80&w=1200",
    category: "Catering",
    alt: "Premium Catering Buffet"
  }
];

export const COMMON_FAQS: FAQ[] = [
  {
    question: "Do you provide catering services?",
    answer: "Yes, we offer full catering services with vegetarian and non-vegetarian options for weddings, parties, and corporate events."
  },
  {
    question: "Do you serve areas outside Midnapore?",
    answer: "Yes, we serve all major areas in Paschim Medinipur including Kharagpur, Ghatal, Jhargram, and nearby towns."
  },
  {
    question: "How far in advance should I book for a wedding?",
    answer: "We recommend booking at least 2-3 months in advance for weddings, especially during the peak season (November to February)."
  },
  {
    question: "Can you organize corporate conferences?",
    answer: "Absolutely! We handle everything from audio-visual setup to seating and lunch for corporate events."
  }
];
